import React, { useState } from 'react'
import { styled, alpha } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Blockchains from './SubNav/Blockchains'
import Validators from './SubNav/Validators'
import { Button, CardMedia } from '@mui/material'
import dexitLogo from '../../Image/logo.svg'
import { ethers } from 'ethers'
import { useLocation, useNavigate } from 'react-router-dom'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import { GifBox } from '@mui/icons-material'
import './Navbar.css'
import InsertLinkIcon from '@mui/icons-material/InsertLink'
import metaMaskLogo from '../../Image/metamask.svg'
import Web3 from 'web3'
import { useWeb3Context } from '../../hooks/web3Context'
import Voting from './SubNav/Voting'
import Connect from './SubNav/Connect'
import Contract from './SubNav/Contract'

export default function Navbar() {
  const { connect, disconnect, address } = useWeb3Context()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const navigate = useNavigate()
  const location = useLocation()
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const [errorMessage, setErrorMessage] = useState(null)
  const [defaultAccount, setDefaultAccount] = useState(null)
  const [userBalance, setUserBalance] = useState(null)
  const [connButtonText, setConnButtonText] = useState('Connect Wa')

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const connectWalletHandler = () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      console.log('MetaMask Here!')

      window.ethereum
        .request({ method: 'eth_requestAccounts' })
        .then((result) => {
          accountChangedHandler(result[0])
          setConnButtonText('Wallet Connected')
          getAccountBalance(result[0])
        })
        .catch((error) => {
          setErrorMessage(error.message)
        })
    } else {
      console.log('Need to install MetaMask')
      setErrorMessage('Please install MetaMask browser extension to interact')
    }
  }

  // update account, will cause component re-render
  const accountChangedHandler = (newAccount) => {
    setDefaultAccount(newAccount)
    // console.log(newAccount,"newAccount")
    getAccountBalance(newAccount.toString())
  }

  const getAccountBalance = (account) => {
    window.ethereum
      .request({ method: 'eth_getBalance', params: [account, 'latest'] })
      .then((balance) => {
        setUserBalance(ethers.utils.formatEther(balance))
      })
      .catch((error) => {
        setErrorMessage(error.message)
      })
  }

  const chainChangedHandler = () => {
    // reload the page to avoid any errors with chain change mid use of application
    window.location.reload()
  }

  // listen for account changes
  try {
    window.ethereum.on('accountsChanged', accountChangedHandler)

    window.ethereum.on('chainChanged', chainChangedHandler)
  } catch (error) {}

  // const handleRoute = () => {
  //   navigate("/staking");
  // };

  const handleHome = () => {
    navigate('/')
  }

  const handleBlock = () => {
    navigate('/allblocks')
  }

  const handleVoting = () => {
    navigate('/voting')
  }

  const mobileMenuId = 'primary-search-account-menu-mobile'

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleHome()}
          className="nav-button-mobile"
        >
          Home
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleStack()}
          className="nav-button-mobile"
        >
          Stake
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleUnStack()}
          className="nav-button-mobile"
        >
          UnStake
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="small"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleBlock()}
          className="nav-button-mobile"
        >
          Blocks
        </IconButton>
      </MenuItem>

      {/* <MenuItem>
        <IconButton
          size="small"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleFaucet()}
        >
          Faucet
        </IconButton>
      </MenuItem> */}

      {/* <MenuItem>
          <IconButton
            size="small"
            aria-label="show 4 new mails"
            color="inherit"
            onClick={() => handleSwap()}
          >
            Swap
          </IconButton>
        </MenuItem> */}

      {/* <MenuItem>
        <IconButton
          size="small"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleDeploy()}
        >
          Deploy
        </IconButton>
      </MenuItem> */}

      {/* <MenuItem>
          <IconButton
            size="small"
            aria-label="show 4 new mails"
            color="inherit"
            onClick={()=>handleVoting()}
          >
            Voting
          </IconButton>
        </MenuItem> */}

      {/* <MenuItem>
          <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="inherit"
            onClick={()=>handleVoting()}
          >
            Voting
            <Blockchains />
          </IconButton>
        </MenuItem> */}

      <MenuItem>
        <Voting />
      </MenuItem>
      <MenuItem>
        <Contract />
      </MenuItem>
      <MenuItem>
        <Validators />
      </MenuItem>

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Connect />
        </IconButton>
      </MenuItem> */}

      {/* <MenuItem>
          <IconButton
            size="large"
            aria-label="show more"
            aria-haspopup="true"
            onClick={connectWalletHandler}
            color="inherit"
          >
            <CardMedia component="img" height="50" image={metaMaskLogo} />
          </IconButton>
        </MenuItem> */}
    </Menu>
  )

  if (
    location.pathname === '/allblocks' ||
    location.pathname === '/alltransactions'
  )
    return null

  const handleStack = () => {
    navigate('/staking')
  }

  const handleUnStack = () => {
    navigate('/unstaking')
  }

  const navigatRoute = () => {
    navigate('/')
  }

  const handleDeposite = () => {
    navigate('/deposit')
  }

  const handleFaucet = () => {
    navigate('/faucet')
  }

  const handleSwap = () => {
    navigate('/swap')
  }

  const handleDeploy = () => {
    navigate('/deploy')
  }

  return (
    <>
      <Box sx={{ flexGrow: 1, background: '#2C2E3F' }}>
        <AppBar
          position="static"
          sx={{
            color: '#8997B1',
            background: 'transparent',
            boxShadow: 'none',
            maxWidth: '1200px',
            margin: 'auto',
          }}
        >
          <Toolbar>
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Box
              size="large"
              edge="start"
              color="inherit"
              // aria-label="open drawer"
              sx={{ cursor: 'pointer' }}
              onClick={navigatRoute}
            >
              <img src={dexitLogo} alt="dexitlogo" style={{ width: '120px' }} />
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box
              sx={{
                mx: 2,
                display: { xs: 'none', lg: 'flex', alignItems: 'center' },
              }}
            >
              <Button
                onClick={() => handleHome()}
                disableElevation
                className="nav-button acive"
              >
                Home
              </Button>

              <Button
                disableElevation
                className="nav-button"
                onClick={handleStack}
              >
                Stake
              </Button>

              <Button
                disableElevation
                className="nav-button"
                onClick={handleUnStack}
              >
                UnStake
              </Button>

              <Button
                onClick={() => handleBlock()}
                disableElevation
                className="nav-button"
              >
                Blocks
              </Button>

              {/* <Button
                
                onClick={() => handleFaucet()}
                disableElevation
                className="nav-button"
              >
                Faucet
              </Button> */}

              {/* <Button
              
              onClick={() => handleSwap()}
              disableElevation
              sx={{ border: "none", color: "#8997B1", padding: '6px' }}
            >
              Swap
            </Button> */}

              {/* <Button
                
                onClick={() => handleDeploy()}
                disableElevation
                className="nav-button"
              >
                Deploy
              </Button> */}

              <Box>
                <Voting />
              </Box>
              <Box>
                <Contract />
              </Box>

              {/* <Box
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              sx={{border: "none", color: "#8997B1", padding: '6px'}}
              onClick={()=>handleVoting()}
            >
               <span style={{ fontSize: "14px",  textTransform: "none" }}>
                Voting
              </span>
              <Blockchains />
            </Box> */}
              <Box>
                <Validators />
              </Box>

              {/* <Box>
                <Connect />
              </Box> */}

              {/* <Button
                
                color="error"
                variant="contained"
                onClick={connectWalletHandler}
              >
                Connect
              </Button>

              <IconButton
                size="large"
                aria-label="show more"
                aria-haspopup="true"
                onClick={connectWalletHandler}
                color="inherit"
              >
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<InsertLinkIcon />}
                >
                  Connet Wallet
                </Button>
              </IconButton> */}
            </Box>
            {!address ? (
              <Button
                color="primary"
                className="blocksBtn connect-button"
                variant="contained"
                onClick={connect}
                size="large"
              >
                Connect
              </Button>
            ) : (
              <Button
                color="primary"
                className="blocksBtn connect-button"
                variant="contained"
                onClick={disconnect}
                size="large"
              >
                Disconnect
              </Button>
            )}
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
      </Box>
    </>
  )
}
